import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Box, Chip, useTheme } from "@mui/material";
import React from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import { lowerCaseToCapCase } from "@/utils";

export type RecipientFeed = {
  id: string;
  title: string;
  commandAlias?: { id: string; alias: string }[];
};

/**
 * A single selectable feed row in the fleet-message recipient pickers. Extracted so the grouped and
 * non-grouped lists share one markup and can be handed to a virtualizer as a stable child component
 * (only the visible rows mount, which is what keeps a 2500-channel workspace from freezing).
 */
export default React.memo(function RecipientFeedRow({
  feed,
  active,
  onToggle,
}: {
  feed: RecipientFeed;
  active: boolean;
  onToggle: (id: string) => void;
}) {
  const theme = useTheme();
  return (
    <button
      data-sb={TestIds.fleet.recipient}
      className="basic-button"
      style={{ width: "100%", marginBottom: 1 }}
      onClick={() => onToggle(feed.id)}
    >
      {active ? (
        <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
      ) : (
        <CheckBoxOutlineBlankIcon sx={{ color: theme.palette.brand.other.gray.main }} />
      )}
      <Box sx={{ display: "flex", width: "100%", gap: 1 }}>
        <Box sx={{ pt: feed?.commandAlias?.length ? 2 : 0 }}>
          <Box sx={{ flexGrow: 1, textAlign: "left" }}>{feed.title}</Box>

          {feed?.commandAlias?.length > 0 && (
            <Box sx={{ display: "flex", fontSize: "10px", gap: 1 }}>
              {feed.commandAlias.map((alias) => (
                <Chip
                  key={alias.id}
                  label={lowerCaseToCapCase(alias.alias)}
                  size="small"
                  sx={{
                    py: 0.15,
                    width: "auto",
                    height: "auto",
                    background: theme.palette.info.main,
                  }}
                />
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </button>
  );
});
